import { inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';
import { of } from 'rxjs';
import { catchError, map, take } from 'rxjs/operators';
import { AuthService } from '../../services/auth';
import { SubscriptionService } from '../../services/api/subscription.service';
import { PlanExpiredService } from '../../services/plan-expired.service';
import { RoleId } from '../models/role.model';

export const planGuard: CanActivateFn = () => {
  const auth             = inject(AuthService);
  const subscriptionService = inject(SubscriptionService);
  const planExpiredSvc   = inject(PlanExpiredService);

  // El Administrador nunca es bloqueado
  if (auth.hasRoleId(RoleId.ADMINISTRADOR)) {
    return true;
  }

  // Solo aplica a Gestor y Editor
  const isGestor = auth.hasRoleId(RoleId.GESTOR);
  const isEditor = auth.hasRoleId(RoleId.EDITOR);

  if (!isGestor && !isEditor) {
    return true;
  }

  return subscriptionService.getMySubscription().pipe(
    take(1),
    map(res => {
      //Muestra el banner
      planExpiredSvc.setPlanData(res?.data ?? null);
      return true;
    }),
    catchError(() => {
      // 
      planExpiredSvc.setPlanData(null);
      return of(true);
    })
  );
};
